module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-lincoln.4b205533.png";